/**
 * Explicit permissions for high-risk portfolio-performance operations.
 *
 * These are intentionally separated from generic report-read authority: a
 * user who can inspect reports must not thereby calculate, approve, publish,
 * post, correct, or reopen financial state.
 */
export const PORTFOLIO_PERFORMANCE_PERMISSION_REGISTRY = Object.freeze({
    'organization:performance-returns:read': {
        id: 'organization:performance-returns:read',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Read governed portfolio performance return facts',
    },
    'organization:performance-returns:calculate': {
        id: 'organization:performance-returns:calculate',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Calculate governed portfolio performance return facts',
    },
    'organization:performance-returns:correction-request': {
        id: 'organization:performance-returns:correction-request',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Request a governed performance-return correction',
    },
    'organization:performance-returns:correction-approve': {
        id: 'organization:performance-returns:correction-approve',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Approve a governed performance-return correction',
    },
    'organization:performance-returns:correction-finalize': {
        id: 'organization:performance-returns:correction-finalize',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Finalize a governed performance-return correction',
    },
    'organization:fixed-income-valuations:calculate': {
        id: 'organization:fixed-income-valuations:calculate',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Calculate a governed fixed-income valuation',
    },
    'organization:fixed-income-lifecycle:schedule': {
        id: 'organization:fixed-income-lifecycle:schedule',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Schedule a governed fixed-income lifecycle event',
    },
    'organization:fixed-income-lifecycle:approve': {
        id: 'organization:fixed-income-lifecycle:approve',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Approve a governed fixed-income lifecycle event',
    },
    'organization:fixed-income-lifecycle:post': {
        id: 'organization:fixed-income-lifecycle:post',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Post an approved fixed-income lifecycle event',
    },
    'organization:fixed-income-debt-events:process': {
        id: 'organization:fixed-income-debt-events:process',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Process a published fixed-income issuer debt event',
    },
    'organization:valuation-runs:read': {
        id: 'organization:valuation-runs:read',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Read governed portfolio valuation runs',
    },
    'organization:valuation-runs:create': {
        id: 'organization:valuation-runs:create',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Create a governed portfolio valuation run',
    },
    'organization:valuation-runs:approve': {
        id: 'organization:valuation-runs:approve',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Approve a governed portfolio valuation run',
    },
    'organization:valuation-runs:publish': {
        id: 'organization:valuation-runs:publish',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Publish an approved portfolio valuation run',
    },
    'organization:valuation-runs:reopen-request': {
        id: 'organization:valuation-runs:reopen-request',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Request reopening of a published portfolio valuation run',
    },
    'organization:valuation-runs:reopen-approve': {
        id: 'organization:valuation-runs:reopen-approve',
        authority: 'ORGANIZATION',
        resourceScope: 'PORTFOLIO',
        description: 'Approve reopening of a published portfolio valuation run',
    },
});
